/**
 * Country Autocomplete System
 * Converts WooCommerce country select fields to modern autocomplete inputs
 */

// Global variables for country autocomplete
var countryAutocompleteSystem = {};

function getLocalCountryMap() {
    try {
        if (window.vs_countries_list && typeof window.vs_countries_list === 'object') {
            return window.vs_countries_list;
        }
        if (window.vs_countries && typeof window.vs_countries === 'object') {
            return window.vs_countries;
        }
        if (window.wc_country_select_params && typeof window.wc_country_select_params.countries === 'object') {
            return window.wc_country_select_params.countries;
        }
    } catch (e) {}
    return null;
}

function getLocalCountryArray() {
    var map = getLocalCountryMap();
    if (!map) {
        return null;
    }
    var arr = [];
    try {
        Object.keys(map).forEach(function(code) {
            arr.push({ code: code, name: map[code] });
        });
        return arr;
    } catch (e) {
        for (var key in map) {
            if (Object.prototype.hasOwnProperty.call(map, key)) {
                arr.push({ code: key, name: map[key] });
            }
        }
        return arr;
    }
}

function initCountryAutocompleteSystem() {
    
    // Ensure jQuery is available
    var $ = jQuery;
    window.vsCountryDebug = window.vsCountryDebug || [];
    window.vsCountryDebug.push({
        ts: Date.now(),
        event: 'country_autocomplete_init'
    });
    
    function convertCountrySelectToAutocomplete($select) {
        if ($select.data('converted-to-autocomplete')) {
            return;
        }
        
        // Hide the original select and any Select2 containers immediately
        $select.hide();
        $select.next('.select2-container').hide();
        $('.select2-container[data-select2-id="' + $select.attr('id') + '"]').hide();
        
        var fieldId = $select.attr('id');
        var fieldName = $select.attr('name');
        var currentValue = $select.val() || 'DE';
        var currentText = $select.find('option:selected').text();
        var $wrapper = $select.closest('.form-row');
        var $label = $wrapper.find('label');
        var required = $select.prop('required') ? ' required' : '';
        var isRequired = $select.prop('required');
        
        // Get country name from code
        var countryName = '';
        if (currentValue && currentValue !== '' && currentText !== 'Bitte wählen') {
            countryName = currentText;
        } else if (currentValue === 'DE') {
            countryName = 'Deutschland';
        }
        
        
        // Create autocomplete HTML
        var autocompleteHtml = 
            '<div class="country-autocomplete-wrapper">' +
                '<input type="hidden" id="' + fieldId + '" name="' + fieldName + '" value="' + currentValue + '"' + required + '>' +
                '<input type="text" ' +
                       'id="' + fieldId + '_display" ' +
                       'class="country-autocomplete-input floating-label-input" ' +
                       'value="' + countryName + '"' +
                       'placeholder="Land eingeben oder auswählen..."' +
                       'autocomplete="country-name"' +
                       'data-target="' + fieldId + '">' +
                '<div class="country-autocomplete-dropdown" id="' + fieldId + '_dropdown"></div>' +
            '</div>';
        
        // Replace the select with autocomplete
        $select.replaceWith(autocompleteHtml);
        $select.data('converted-to-autocomplete', true);
        
        // Update wrapper classes
        $wrapper.addClass('country-autocomplete-field');
        $wrapper.removeClass('woocommerce-input-wrapper');
        
        // Handle label for floating effect
        if ($label.length) {
            $label.addClass('floating-label');
            if (isRequired && $label.find('.required').length === 0) {
                $label.append(' <abbr class="required" title="required">*</abbr>');
            }
            
            // Move label inside wrapper
            $wrapper.find('.country-autocomplete-wrapper').append($label);
        }
        
        // Initialize autocomplete functionality
        initCountryAutocompleteField(fieldId);
        
        // DEBUG: ✅ Converted country select to autocomplete:;
    }
    
    function initCountryAutocompleteField(fieldId) {
        var $input = $('#' + fieldId + '_display');
        var $hiddenField = $('#' + fieldId);
        var $dropdown = $('#' + fieldId + '_dropdown');
        var $label = $input.closest('.country-autocomplete-field').find('.floating-label');
        var searchTimeout;
        var currentRequest;
        
        
        // Set initial floating label state
        if ($input.val() && $input.val().trim() !== '') {
            $label.addClass('active');
        }
        
        // Handle floating label behavior
        $input.on('focus', function() {
            $label.addClass('active');
            if ($(this).val().trim().length === 0) {
                showPopularCountries();
            }
        }).on('blur', function() {
            setTimeout(function() {
                if (!$dropdown.is(':hover') && (!$input.val() || $input.val().trim() === '')) {
                    $label.removeClass('active');
                }
                $dropdown.removeClass('show');
            }, 150);
        }).on('input', function() {
            var query = $(this).val().trim();
            
            if ($(this).val() && $(this).val().trim() !== '') {
                $label.addClass('active');
            } else {
                $label.removeClass('active');
            }
            
            clearTimeout(searchTimeout);
            if (currentRequest) currentRequest.abort();
            
            if (query.length < 2) {
                $dropdown.removeClass('show').empty();
                return;
            }
            
            searchTimeout = setTimeout(function() {
                searchCountries(query);
            }, 300);
        });
        
        // Show popular countries
        function showPopularCountries() {
            var localList = getLocalCountryArray();
            var preferredCodes = ["DE","AT","CH","FR","IT","NL","BE","ES"];
            var popularCountries = [];
            if (localList && localList.length) {
                preferredCodes.forEach(function(code){
                    var match = localList.find(function(item){ return item.code === code; });
                    if (match) {
                        popularCountries.push(match);
                    }
                });
                if (popularCountries.length === 0) {
                    popularCountries = localList.slice(0, 8);
                }
            } else {
                popularCountries = [
                    {code: "DE", name: "Deutschland"},
                    {code: "AT", name: "Österreich"},
                    {code: "CH", name: "Schweiz"},
                    {code: "FR", name: "Frankreich"},
                    {code: "IT", name: "Italien"},
                    {code: "NL", name: "Niederlande"},
                    {code: "BE", name: "Belgien"},
                    {code: "ES", name: "Spanien"}
                ];
            }
            
            displayCountries(popularCountries);
        }
        
        // Search countries via AJAX
        function searchCountries(query) {
            var localList = getLocalCountryArray();
            if (localList && localList.length) {
                var lower = query.toLowerCase();
                var filtered = localList.filter(function(item){
                    return (item.name && item.name.toLowerCase().indexOf(lower) !== -1)
                        || (item.code && item.code.toLowerCase().indexOf(lower) !== -1);
                }).slice(0, 10);
                displayCountries(filtered);
                return;
            }
            $dropdown.html('<div class="country-autocomplete-loading">🔍 Suche Länder...</div>').addClass('show');
            
            currentRequest = $.ajax({
                url: vitalshop_checkout.ajax_url,
                type: "POST",
                data: {
                    action: "search_countries",
                    query: query,
                    nonce: vitalshop_checkout.search_countries_nonce
                },
                success: function(response) {
                    if (response.success) {
                        displayCountries(response.data);
                    } else {
                        if (localList && localList.length) {
                            displayCountries(localList.slice(0, 10));
                        } else {
                            $dropdown.html('<div class="country-autocomplete-empty">❌ Keine Länder gefunden</div>');
                        }
                    }
                },
                error: function() {
                    if (localList && localList.length) {
                        displayCountries(localList.slice(0, 10));
                    } else {
                        $dropdown.html('<div class="country-autocomplete-empty">❌ Fehler beim Suchen</div>');
                    }
                }
            });
        }
        
        // Display country results
        function displayCountries(countries) {
            $dropdown.empty();
            
            if (countries.length === 0) {
                $dropdown.html('<div class="country-autocomplete-empty">❌ Keine Länder gefunden</div>');
                return;
            }
            
            var currentValue = $hiddenField.val();
            
            countries.forEach(function(country) {
                var $item = $('<div>')
                    .addClass('country-autocomplete-item')
                    .html('<span class="country-code">' + country.code + '</span><span class="country-name">' + country.name + '</span>')
                    .data('code', country.code)
                    .data('name', country.name);
                
                // Highlight currently selected country
                if (country.code === currentValue) {
                    $item.addClass('selected-country');
                }
                
                $item.on('click', function() {
                    selectCountry($(this));
                });
                
                $dropdown.append($item);
            });
            
            $dropdown.addClass('show');
        }
        
        // Select a country
        function selectCountry($item) {
            var code = $item.data('code');
            var name = $item.data('name');
            
            window.vsCountryDebug.push({
                ts: Date.now(),
                event: 'selectCountry',
                payload: { code: code, name: name }
            });
            
            $hiddenField.val(code);
            $input.val(name);
            
            // Close dropdown immediately
            $dropdown.removeClass('show').empty();
            $label.addClass('active');
            
            // Remove focus from input to prevent reopening
            $input.blur();
            
            // Trigger change event for WooCommerce
            $hiddenField.trigger('change');
            
            // Sync shipping country hidden field if it exists
            try {
                var $shippingCountry = $('#shipping_country');
                if ($shippingCountry.length === 0) {
                    var $hidden = $('<input>', { type: 'hidden', id: 'shipping_country', name: 'shipping_country', value: code });
                    $('form.checkout').first().append($hidden);
                    $shippingCountry = $('#shipping_country');
                }
                $shippingCountry.val(code).trigger('change');
            } catch (e) {}
            
            // Persist manual selection for future reloads
            try { 
                sessionStorage.setItem('vs_country_manually_selected', code);
                sessionStorage.setItem('vs_country_manually_selected_time', Date.now());
            } catch (e) {}
            
            function triggerFullReload() {
                try { sessionStorage.setItem('vs_country_reloading', '1'); } catch (e) {}
                setTimeout(function() { window.location.reload(); }, 150);
            }
            
            // Update WooCommerce session to recalc taxes/shipping
            try {
                if (window.vitalshop_smart_checkout && vitalshop_smart_checkout.ajax_url) {
                    var payload = {
                        action: 'force_wc_session_update',
                        nonce: vitalshop_smart_checkout.nonce,
                        country: code,
                        first_name: $('input[name="billing_first_name"]').val() || '',
                        last_name: $('input[name="billing_last_name"]').val() || '',
                        company: $('input[name="billing_company"]').val() || '',
                        address_1: $('input[name="billing_address_1"]').val() || '',
                        address_2: $('input[name="billing_address_2"]').val() || '',
                        city: $('input[name="billing_city"]').val() || '',
                        postcode: $('input[name="billing_postcode"]').val() || '',
                        state: $('select[name="billing_state"], input[name="billing_state"]').val() || '',
                        phone: $('input[name="billing_phone"]').val() || '',
                        email: (window.vitalshop_smart_checkout.current_user_email || $('input[name="billing_email"]').val() || '')
                    };
                    window.vsCountryDebug.push({
                        ts: Date.now(),
                        event: 'force_wc_session_update_payload',
                        payload: payload
                    });
                    
                    var wcAjax = '';
                    try { wcAjax = (window.wc_checkout_params && wc_checkout_params.wc_ajax_url) ? wc_checkout_params.wc_ajax_url.replace('%%endpoint%%','force_wc_session_update') : ''; } catch(_){}
                    var postUrl = wcAjax || vitalshop_smart_checkout.ajax_url;
                    $.post(postUrl, payload)
                        .done(function(resp){
                            window.vsCountryDebug.push({
                                ts: Date.now(),
                                event: 'force_wc_session_update_success',
                                payload: resp
                            });
                        })
                        .fail(function(err){
                            window.vsCountryDebug.push({
                                ts: Date.now(),
                                event: 'force_wc_session_update_fail',
                                payload: err
                            });
                        })
                        .always(function() {
                            window.vsCountryDebug.push({
                                ts: Date.now(),
                                event: 'force_wc_session_update_reload'
                            });
                            triggerFullReload();
                        });
                } else {
                    window.vsCountryDebug.push({
                        ts: Date.now(),
                        event: 'force_wc_session_update_missing_config'
                    });
                    try { jQuery(document.body).trigger('update_checkout'); } catch (e) {}
                    triggerFullReload();
                }
            } catch (e) {
                window.vsCountryDebug.push({
                    ts: Date.now(),
                    event: 'force_wc_session_update_exception',
                    payload: e
                });
                try { jQuery(document.body).trigger('update_checkout'); } catch (__) {}
                triggerFullReload();
            }
            
        }
        
        // Hide dropdown when clicking outside
        $(document).on('click', function(e) {
            if (!$(e.target).closest($input.parent()).length) {
                $dropdown.removeClass('show');
            }
        });
    }
    
    function convertAllCountrySelects() {
        $('select[name*="_country"]').each(function() {
            // console.log('📍 Found country select:', $(this).attr('name'));
            convertCountrySelectToAutocomplete($(this));
        });
    }
    
    // Convert on page load
    convertAllCountrySelects();
    
    // Make functions globally available
    countryAutocompleteSystem.convertCountrySelectToAutocomplete = convertCountrySelectToAutocomplete;
    countryAutocompleteSystem.convertAllCountrySelects = convertAllCountrySelects;
    
        // DEBUG: ✅ Country Autocomplete System initialized;
}

// Auto-initialize when document is ready
jQuery(document).ready(function($) {
    
    // Wait for checkout to be fully loaded
    setTimeout(function() {
        // DEBUG: 🚀 Starting Country Autocomplete System...;
        initCountryAutocompleteSystem();
    }, 1500);
    
    // Also try after checkout updates
    $(document.body).on('updated_checkout', function() {
        setTimeout(function() {
            if (countryAutocompleteSystem.convertAllCountrySelects) {
                countryAutocompleteSystem.convertAllCountrySelects();
            }
        }, 500);
    });
});